module.exports = __webpack_public_path__ + "img/mycrypto-custom-token-form.ba4faf56.png";